//@ts-nocheck
/* eslint-disable */
import { average } from "../../utils/functions";
import { transformSplit } from "./business-logic/request-splitter";
import { calculateTutorAge } from "./search-fns";
import { interpretTutorData } from "./tutor-fns";
import { generateLessonsForSplit as rawGenerateLessonsForSplit } from "./utils";
export const getGenderOptions = (searchData) => {
  let gender = searchData.map((tutor) => tutor.gender);
  return [...new Set([...gender])];
};

function sortAlphabetically(array) {
  return [...array].sort((a, b) => {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  });
}

export const getEducationDegrees = (searchData) => {
  let degrees = [];
  searchData.forEach((tutor) =>
    tutor.education.forEach((edu) => degrees.push(edu.degree)),
  );

  return sortAlphabetically([...new Set(degrees.filter(Boolean))]);
};

export const getMaximumAge = (searchData) => {
  let tutorAges = searchData.map((tutor) => calculateTutorAge(tutor));
  return Math.max(...tutorAges);
};

const getMaxMinAvgPrice = (searchData, requestData, searchObj) => {
  let tutorPrices = searchData.map(
    (tutor) => interpretTutorData(tutor, requestData, searchObj).price.amount,
  );

  return {
    maximum: Math.max(...tutorPrices).toFixed(),
    minimum: Math.min(...tutorPrices).toFixed(),
    average: average(tutorPrices).toFixed(),
  };
};

const excludedGrades = ["Other grade", "Not applicable"];

const getGraduatingGrades = (searchData) => {
  let grades = [];
  searchData.forEach((tutor) =>
    tutor.education.forEach((edu) => {
      if (!excludedGrades.includes(edu.grade)) grades.push(edu.grade);
    }),
  );
  return sortAlphabetically([...new Set(grades.filter(Boolean))]);
};

export const getEducationCountries = (searchData) => {
  let countries = [];
  searchData.forEach((tutor) =>
    tutor.education.forEach((edu) => countries.push(edu.country)),
  );
  return sortAlphabetically([...new Set(countries.filter(Boolean))]);
};

export const hasPremiumTutors = (searchData) => {
  let premiumTutors = searchData.filter((tutor) => tutor.level === "premium");
  return premiumTutors.length > 0;
};

export const getCurriculumOptions = (searchData) => {
  let curriculum = [];
  searchData.forEach((tutor) => curriculum.push(...tutor.curriculum));
  return [...new Set([...curriculum])];
};

export const getDeliveryOptions = (searchData) => {
  let delivery = [];
  searchData.forEach((tutor) => delivery.push(...tutor.delivery));
  return [...new Set([...delivery])];
};

export function determineNoOfTeachers(childDetails, splitRequests = []) {
  let teacherSplitOptions = transformSplit(childDetails);
  let initialTeacherOption =
    splitRequests.length > 0 ? splitRequests[0].teacherOption : "";

  let teacherOptions = Object.keys(teacherSplitOptions);
  let initialInputValue = teacherOptions.includes(initialTeacherOption)
    ? initialTeacherOption
    : "";
  return { teacherSplitOptions, initialInputValue };
}

export let newChild: any = {
  firstName: "",
  gender: "male",
  classDetail: {
    class: "",
    purpose: "",
    subjects: [],
  },
  expectation: "",
  special_needs: "",
};
export function isEmptyChild(v) {
  const { firstName, classDetail, expectation, special_needs } = v;
  return (
    firstName === ""
    // classDetail.subjects.length === 0 &&
    // classDetail.class === "" &&
    // classDetail.purpose === "" &&
    // expectation === "" &&
    // special_needs === ""
  );
}

export const transformOutput = (data) => {
  let transformedOutput = data.childDetails.map((child) => {
    let {
      classDetail: { class: studentClass, purpose, subjects },
    } = child;

    let newClassDetail = {
      class: formatClass(studentClass),
      purpose: formatValue(purpose),
      subjects: subjects.map((subject) => formatValue(subject)),
    };

    // remove any instance of id
    let { id: _, ..._child } = child;

    return {
      ..._child,
      classDetail: newClassDetail,
      displayName: child.name || child.firstName,
    };
  });
  return transformedOutput;
};

export const formatClass = (studentClass) => {
  return studentClass === "Preschool"
    ? studentClass
    : studentClass.slice(0, studentClass.length - 1) +
        " " +
        studentClass.slice(-1);
};

export const formatValue = (string) => {
  return string.replace(/_/g, " ");
};

export function generateSplitRequests(aboutChildDetails, teacherOption) {
  const cleanedChildDetails = transformOutput(aboutChildDetails);
  const splitResult = transformSplit(cleanedChildDetails);
  const splitRequests = splitResult[teacherOption];
  return splitRequests;
}

/**
 * hourlyRate[i] = baseRate[i] * stateFx * vicinityFx * purposeFx[i] * curriculumFx[i] * onlineFx
 * To determine the purposeFx, if the requestSplit has more than 1 purpose,
 * the highest purposeFx shall be used in this equation, same applies to curriuclumFx
 *
 * The number of elements in hourlyRate, depends on the number of request splits
 * or the number of teachers in the request.
 */

const splitSchedule = (newSchedule, daysSelected, splitRequests) => {
  /**
   * Generates a new "splitRequest" array that includes the number of days of lessons
   * each split or teacher is assigned per week based on if the user selected to have
   * One Teacher, Separate Teachers or Specialized Teachers.
   *
   */

  let newRequestSplit = rawGenerateLessonsForSplit(
    splitRequests,
    newSchedule,
    daysSelected,
  );

  return newRequestSplit;
};

export function generatePlanPricing(
  formValues,
  splitRequests,
  lessonPlan,
  hourlyRate = [1000, 1000, 1000],
  extraStudentFx = 0.2,
  premiumFx = 1.4,
) {
  const { lessonDays, lessonDuration, lessonHours } = formValues;

  const newRequestSplit = splitSchedule(formValues, lessonDays, splitRequests);

  const teacherOption =
    newRequestSplit.length > 0
      ? newRequestSplit[0].teacherOption
      : "One teacher";

  const premimumMultiple = lessonPlan === "Premium" ? premiumFx : 1.0;
  const selectedHours = lessonHours > 1 ? lessonHours : 1.7;

  const discountedHours =
    selectedHours > 3 ? selectedHours - (selectedHours - 3) / 3 : selectedHours;

  const numberOfHours = discountedHours.toFixed(1);

  function getTotalLessons() {
    const lessonReducer = (accumulator, currentValue) => {
      return currentValue.lessonDays
        ? accumulator + currentValue.lessonDays.length
        : accumulator;
    };

    return newRequestSplit.reduce(lessonReducer, 0) * lessonDuration;
  }

  const getLessonFee = (hourlyRate, lessonDays = []) => {
    let numberOfLessons = lessonDays.length * lessonDuration;
    let feePerLesson = hourlyRate * numberOfHours * premimumMultiple;
    return feePerLesson * numberOfLessons;
  };

  function getTotalPrice() {
    const feeReducer = (accumulator, currentValue, index) => {
      let additionalStudents = currentValue.names.length - 1;
      if (currentValue.lessonDays) {
        let lessonFee =
          getLessonFee(hourlyRate[index], currentValue.lessonDays) *
          (1 + additionalStudents * extraStudentFx);
        return accumulator + Math.ceil(lessonFee / 10) * 10;
      }
      return accumulator;
    };
    let rrr = newRequestSplit.reduce(feeReducer, 0);
    return rrr;
  }

  let modalHeading =
    newRequestSplit.length === 1
      ? "One teacher"
      : `${newRequestSplit.length} ${teacherOption}`;

  return {
    numberOflessons: getTotalLessons(),
    totalPrice: getTotalPrice(),
    splitRequests: newRequestSplit,
    numberOfHours,
    hoursSelected: lessonHours,
    hourlyRate,
    extraStudentFx,
    premimumMultiple,
    premiumFx,
    modalHeading,
    duration: lessonDuration,
  };
}

const calculateFee = (
  hourlyRate,
  lessonDays = [],
  hours,
  lessonPlan,
  premiumFx,
  extraStudentFx,
  students = [],
  duration,
) => {
  const premimumMultiple = lessonPlan === "Premium" ? premiumFx : 1.0;
  const selectedHours = hours > 1 ? hours : 1.7;
  const discountedHours =
    selectedHours > 3 ? selectedHours - (selectedHours - 3) / 3 : selectedHours;
  const numberOfHours = discountedHours.toFixed(1);
  let numberOfLessons = lessonDays.length * duration;
  let feePerLesson = hourlyRate * numberOfHours * premimumMultiple;
  const baseRate = feePerLesson * numberOfLessons;
  const additionalStudents = students.length - 1;
  return baseRate * (1 + additionalStudents * extraStudentFx);
};

export function getLessonFee(lessonSchedule, splitRequest) {
  const {
    hourlyRate,
    lessonDays,
    lessonHours,
    lessonPlan,
    extraStudentFx,
    premiumFx,
    lessonDuration,
  } = lessonSchedule;
  const budgetPerSplit = splitRequest.map((sP, i) => {
    return calculateFee(
      hourlyRate[i],
      lessonDays,
      lessonHours,
      lessonPlan,
      premiumFx,
      extraStudentFx,
      sP.names,
      lessonDuration,
    );
  });
  return budgetPerSplit;
}

export {
  ChildrenStore,
  ClientRequestStore,
  LessonScheduleListStore,
  LessonScheduleStore,
  LocationFieldStore,
  ParentFormStore,
  RequestFlowStore,
  SearchContextPropType,
  TeacherSelectStore,
} from "../../stores";
